<template>
	<el-dialog :title="title" :visible.sync="isShow" width="500px">
		<el-row class="container" v-if="isShow">
      <div class="searchBox el-input">
        <input ref="iSearch" type="text" autocomplete="off" placeholder="请输入关键字搜索地址" class="el-input__inner">
      </div>
			<div id="js-container" class="mapContent"></div>
		</el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </div>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: false,
				sourceKey: undefined,
				title: '',
				keyword: '',
				AMapUI: null,
				chooseValue: null
			}
		},
		methods: {
			show(options) {
				const {
					title = '地图选择',
						sourceKey,
				} = options;
				this.title = title;
				this.sourceKey = sourceKey;
				this.isShow = true;
        this.initMap();
			},
			onConfirm() {
				this.isShow = false;
				console.log("地址", this.chooseValue)
				let {
					name = "", // 结果
					address = "", // 大概的地址
					pname = "", // 省份
					cityname = "", // 地级市
					adname = "", // 区
					district = "", // 这个字段同pname、cityname互斥，有他没我
				} = this.chooseValue;
				this.$parent.updateForm({
					[this.sourceKey]: `${name}-${district}${pname == cityname ? "" : pname }${cityname}${adname}${address}`,
				})
			},
			onCancel() {
				this.isShow = false;
			},
			initMap() {
				// 加载PositionPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
				this.AMapUI = window.AMapUI;
				this.AMap = window.AMap;

				this.AMapUI.loadUI(
					["misc/PoiPicker"],
					(PoiPicker) => {
						let mapConfig = {
							zoom: 16,
							resizeEnable: true,
						};
						let map = new this.AMap.Map("js-container", mapConfig);
						// 创建poiPicker
						var InputEvent = this.$refs.iSearch
						let poiPicker = new PoiPicker({
							input: InputEvent
						});
						this.poiPickerReady(poiPicker, map);
						//异步加载地图控件
						this.AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.OverView', 'AMap.Geolocation'], () => {
							// 工具条
							map.addControl(new this.AMap.ToolBar({
								position: "RB"
							}));
							// 比例尺
              // map.addControl(new this.AMap.Scale());
							// 缩略图
							map.addControl(new this.AMap.OverView({
								isOpen: false
							}));
							// 定位按钮
							map.addControl(new this.AMap.Geolocation());
						});
					}
				);
			},
			poiPickerReady(poiPicker, map) {
				window.poiPicker = poiPicker;
				var marker = new this.AMap.Marker();
				var infoWindow = new this.AMap.InfoWindow({
					offset: new this.AMap.Pixel(0, -20)
				});
				let _this = this;
				//选取了某个POI
				poiPicker.on("poiPicked", function(poiResult) {
					console.log("选取了某个POI", poiResult)
					_this.chooseValue = poiResult.item;
					let {
						name = "", // 结果
						location: Location = "", // 经纬度信息
						address = "", // 大概的地址
						pname = "", // 省份
						cityname = "", // 地级市
						adname = "", // 区
						district = "", // 这个字段同pname、cityname互斥，有他没我
					} = poiResult.item;
					_this.keyword = name;
					marker.setMap(map);
					infoWindow.setMap(map);
					marker.setPosition(Location);
					infoWindow.setPosition(Location);
					infoWindow.setContent(
						"位置信息: <p>名称:" +
						name +
						"</p>" +
						"<p>地址:" +
						`${district}${pname == cityname ? "" : pname }${cityname}${adname}${address}` +
						"</p>"
					);
					infoWindow.open(map, marker.getPosition());
					map.setCenter(marker.getPosition());
				});
				poiPicker.onCityReady(function() {
					poiPicker.suggest(_this.keyword);
				});
			}
		}
	}
</script>

<style scoped="scoped">
   .container .searchBox {
    margin-bottom: 8px;
  }
   .container .mapContent {
    width: 100%;
    height: 350px;
  }
</style>



// WEBPACK FOOTER //
// src/components/mapEditor.vue